import React from "react";
import ReactDOM from "react-dom";
import ModuleFolders from "./ModuleFolders";

export default class FolderTree extends React.Component {

    constructor(props) {
        super(props);
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }


    componentDidMount() {
        this.getDomSelf().find(".collapse").collapse('show');
        

    }

    render() {
        
        return (
            <div className="panel-group" role="tablist">
                <div className="panel panel-default">
                    {this.props.category !== "__default" && (
                        <div className="panel-heading" role="tab">
                            <div className="panel-title"
                                onClick={() => {
                                    this.getDomSelf().find(".collapse[data-tracker='" + this.props.category + "']").collapse('toggle');
                                }}
                            >
                                {this.props.type} Tree Configuration
                            </div>
                        </div>
                    )}
                    <div className="panel-collapse collapse in" role="tabpanel" data-tracker={this.props.category}>
                        <div className="panel-body">
                            <div className="row jstree jstree-4 jstree-default" id={this.props.idname}>
                            <ModuleFolders type={this.props.type} />
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
